import React, { FC, memo } from "react";
import { ISvG } from "~/types/SvGTypes";

const Icon: FC<ISvG> = ({ fill = "#FFF" }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="19.25"
      height="22"
      viewBox="0 0 19.25 22"
    >
      <g id="zip" transform="translate(-565 -298)">
        <g id="file-extension" transform="translate(565 298)">
          <path
            id="Контур_725"
            data-name="Контур 725"
            d="M20.7,0H32.387l6.192,6.168V20.625A1.375,1.375,0,0,1,37.2,22H20.7a1.375,1.375,0,0,1-1.375-1.375V1.375A1.375,1.375,0,0,1,20.7,0Z"
            transform="translate(-19.329)"
            fill="#9fa4a7"
          />
          <path
            id="Контур_726"
            data-name="Контур 726"
            d="M209.125,6.367h-4.793a1.375,1.375,0,0,1-1.375-1.375V.193Z"
            transform="translate(-189.894 -0.179)"
            fill="#747779"
          />
          <path
            id="Контур_825"
            data-name="Контур 825"
            d="M1.4-1.007H3.308v.742H.193V-.774L2.1-3.521H.182v-.745H3.289v.495Zm3.545.742H3.98v-4h.962Zm1.8-1.357V-.266H5.78v-4h1.6a1.859,1.859,0,0,1,.812.169,1.273,1.273,0,0,1,.547.481,1.313,1.313,0,0,1,.194.707,1.157,1.157,0,0,1-.419.935,1.738,1.738,0,0,1-1.15.35Zm0-.745h.632a.6.6,0,0,0,.427-.14.521.521,0,0,0,.147-.4A.643.643,0,0,0,7.8-3.351a.535.535,0,0,0-.412-.17H6.744Z"
            transform="translate(4 17)"
            fill="#fff"
          />
        </g>
        <g id="zip-2" transform="translate(569 298)">
          <g
            id="Сгруппировать_4114"
            data-name="Сгруппировать 4114"
            transform="translate(2 2)"
          >
            <g
              id="Сгруппировать_4113"
              data-name="Сгруппировать 4113"
              transform="translate(0)"
            >
              <rect
                id="Прямоугольник_855"
                data-name="Прямоугольник 855"
                width="2"
                height="2"
                fill="#fff"
              />
            </g>
          </g>
          <g
            id="Сгруппировать_4116"
            data-name="Сгруппировать 4116"
            transform="translate(0 0)"
          >
            <g
              id="Сгруппировать_4115"
              data-name="Сгруппировать 4115"
              transform="translate(0)"
            >
              <rect
                id="Прямоугольник_856"
                data-name="Прямоугольник 856"
                width="2"
                height="2"
                fill="#fff"
              />
            </g>
          </g>
          <g
            id="Сгруппировать_4118"
            data-name="Сгруппировать 4118"
            transform="translate(0 4)"
          >
            <g
              id="Сгруппировать_4117"
              data-name="Сгруппировать 4117"
              transform="translate(0)"
            >
              <rect
                id="Прямоугольник_857"
                data-name="Прямоугольник 857"
                width="2"
                height="2"
                fill="#fff"
              />
            </g>
          </g>
          <g
            id="Сгруппировать_4120"
            data-name="Сгруппировать 4120"
            transform="translate(2 6)"
          >
            <g
              id="Сгруппировать_4119"
              data-name="Сгруппировать 4119"
              transform="translate(0)"
            >
              <rect
                id="Прямоугольник_858"
                data-name="Прямоугольник 858"
                width="2"
                height="2"
                fill="#fff"
              />
            </g>
          </g>
          <g
            id="Сгруппировать_4122"
            data-name="Сгруппировать 4122"
            transform="translate(0 8)"
          >
            <g
              id="Сгруппировать_4121"
              data-name="Сгруппировать 4121"
              transform="translate(0)"
            >
              <rect
                id="Прямоугольник_859"
                data-name="Прямоугольник 859"
                width="2"
                height="2"
                fill="#fff"
              />
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};

export default memo(Icon);
